<template>
  <v-app>
    <v-toolbar color="primary" fixed dark app
      ><v-toolbar-title class="ms-0 ps-3"> {{ $t("app.name") }} </v-toolbar-title>
    </v-toolbar>
    <v-content>
      <v-container fluid fill-height>
        <v-layout align-center justify-center>
          <v-card style="width: 500px">
            <v-card-title primary-title>
              <div>
                <div class="headline ps-2 pa-1">
                 {{ $t("auth.resetPassword") }}
                </div>
              </div>
            </v-card-title>
            <v-form ref="form" v-model="form" class="pa-4 pt-6">
              <v-text-field
                outline
                v-model="model.username"
                :rules="[rules.email]"
                :label='$t("auth.emailAddress")'
                type="email"
                @keyup.enter="sendEmail"
              ></v-text-field>

              <v-subheader style="padding-top: 15px"
                    ><router-link to="/"
                      >{{ $t("auth.login") }}</router-link
                    ></v-subheader>

              <v-btn
                @click="sendEmail"
                :loading="loading"
                block
                color="secondary"
                dark
                >{{ $t("auth.sendEmail") }}</v-btn
              >
            </v-form>
          </v-card>
        </v-layout>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>


export default {
  title: "auth.resetPassword",
  data: () => ({
    loading: false,
    error: false,
    model: {
      username: ""
    },
    socket: null,
    dialog: false,
    email: undefined,
    form: false,
    isLoading: false,
    password: undefined,
  }),
  computed: {
    rules() {
      return {
        email: (v) => !!(v || "").match(/@/) || this.$t("auth.invalidEmail"),
        length: (len) => (v) =>
          (v || "").length >= len || this.$t("auth.invalidLength", { len }),
        password: (v) =>
          !!(v || "").match(/^.{4,15}$/) || this.$t("auth.passwordLengthRule"),
        required: (v) => !!v || this.$t("auth.fieldRequired"),
      };
    },
  },
  // mounted() {
  //   this.axios
  //     .get(this.api.ACTIONS.GET_LOGIN_IDENTFIER)
  //     .then(({ data: { data: qrCode } }) => {
  //       QRCode.toDataURL(qrCode, {
  //         errorCorrection: "high",
  //         version: 4,
  //       }).then((data) => {
  //         this.qrCode = data;
  //         this.socket = io(this.api.SOCKET.GUESTS, {
  //           transportOptions: {
  //             polling: {
  //               extraHeaders: {
  //                 authorization: qrCode,
  //               },
  //             },
  //           },
  //         });
  //         this.socket.on("authenticate", async (token) => {
  //           await this.$store.dispatch("validateToken", token);
  //           // const user = this.$store.state.user;
  //           let next = this.$route.query.next || "/dashboard";
  //           // if (this.airportAgency(user.roles))
  //           //     next = 'airport/create';
  //           window.getApp.$emit("APP_LOGIN_SUCCESS");
  //           await this.$router.push(next);
  //         });
  //       });
  //     });
  // },
  methods: {
    async sendEmail() {
      if (!this.$refs.form.validate())
        return;
      this.error = false;
      this.loading = true;
      console.log(this.model);
      this.axios
        .post(this.api.ACTIONS.RESET_PASSWORD_EMAIL, { ...this.model, provider: "users" })
        .then(({ data }) => {
          
          window.getApp.$emit("RESET_EMAIL_SENT");
          // QA V4 W3 (#23): carry the entered email to the reset form so the
          // user does not have to retype it alongside the code they received.
          this.$router.push({ path: '/reset-password', query: { email: this.model.username } });
        })
        .catch((err) => {
          console.log(err.message);
          this.error = true;
          let response = err.response;
          if (response) {
            window.getApp.$emit("SHOW_TOAST", response.data.message, "red");
            console.log(response.data);
          } else {
            window.getApp.$emit("SHOW_TOAST", this.$t("auth.checkInfo"), "red");
          }
        })
        .then(() => (this.loading = false));
    },
  },
};
</script>
<style scoped lang="css">
#login {
  height: 50%;
  width: 100%;
  position: absolute;
  top: 0;
  inset-inline-start: 0;
  content: "";
  z-index: 0;
}
</style>
